import React, { Fragment } from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';
import {
  PageHeader,
  SimpleDataTable,
  Section,
  slugify,
  makeBreadcrumb,
  GatsbyLink
} from '@budget-monorepo/shared-ui';

import Layout from '../components/Layout';
import HelmetData from '../components/HelmetData';
import PlanFilter from '../components/PlanFilter';

const GovLevelOne = (props) => {
  const { location, data } = props;
  const { content, site } = data;
  // eslint-disable-next-line camelcase
  const { modifiedTime, mg_mod_date, mg_mod_datetime } = content.parent.parent;
  const path = location.pathname;
  const pathPrefix = process.env.GATSBY_PATH_PREFIX;
  const relPath = path.replace(pathPrefix, '');
  const { pageTitle, breadcrumbprops } = makeBreadcrumb({
    href: '/beneficiary-agency',
    text: 'Plan by Beneficiary Agency',
    sections: [content.govLevelOne]
  });
  const layoutProps = {
    activeIndex: 1,
    pre: () => <PlanFilter path={relPath} />,
    above: () => <PageHeader title={content.title} />,
    pageTitle,
    breadcrumbprops,
    dataTimeStamp: modifiedTime,
    buildTimeStamp: site.buildTime,
    containerClasses: 'main-content main-content--two'
  };
  const { data: benData, ...tableRest } = content.beneficiaryTable;
  const tableData = benData.map((item) => {
    const href = `${content.fields.slug}/${slugify(item.govLevelTwo)}`;
    return Object.assign({}, item, {
      govLevelTwo: <GatsbyLink to={href}>{item.govLevelTwoDisplay}</GatsbyLink>
    });
  });
  const tableProps = { data: tableData, ...tableRest };
  // metadata for the page
  const metaTitle = content.title;
  const metaDescription = `Capital investment plan by beneficiary state organization - ${content.title}.`;
  return(
    <Fragment>
      <HelmetData {...{
        metaTitle,
        metaDescription,
        metaType: 'dataset',
        mg_mod_date,
        mg_mod_datetime
      }}
      />
      <Layout {...layoutProps}>
        {content.beneficiaryTable
          && (
          <Section>
            <React.Fragment>
              <SimpleDataTable title={content.title} table={tableProps} maxColWidth={375} download={location.pathname} />
            </React.Fragment>
          </Section>
          )
        }
      </Layout>
    </Fragment>
  );
};

GovLevelOne.propTypes = {
  data: PropTypes.object,
  pageContext: PropTypes.object,
  location: PropTypes.object
};

export default GovLevelOne;

export const query = graphql`
  query($slug: String!) {
    site {
      ...SiteMetadata
    }
    content: planGovLevelOne(fields: { slug: { eq: $slug } }) {
      title
      budgetSection
      govLevelOne
      fields {
        slug
      }
      beneficiaryTable {
        headers {
          name
          type
          align
          value
        }
        data {
          govLevelTwo
          govLevelTwoDisplay
          stateBondCap
          nonBondCap
          operatingFunds
          federalFunds
          globalTrustFund
          otherFunds
          total
        }
        total {
          govLevelTwo
          stateBondCap
          nonBondCap
          operatingFunds
          federalFunds
          globalTrustFund
          otherFunds
          total
        }
      }
      # Get the last modified timestamp for the file powering the plan item pages
      ...PlanGovLevelOneDataTimeStamp
    }
  }
`;
